import { useState, useEffect, Fragment } from 'react'
import {Helmet} from "react-helmet"
import { useSelector, useDispatch } from 'react-redux'
import { Routes, Route, Link, useLocation } from "react-router-dom";


import useMedia from "./js/js/useMedia"
import Base64 from "./js/Base64"


import LoginMenu from "./js/HEADER/LoginMenu"
import UserMenu from "./js/HEADER/UserMenu"

import ShapkaPreloader from "./js/HEADER/ShapkaPreloader"
import MainPage_DeskTop from "./js/MainPage_DeskTop"
import MainPage_Mobile from "./js/MainPage_Mobile"
import Login from "./js/LOGIN/Login"
import LogOut from "./js/LOGIN/Logout"
import Registration from "./js/LOGIN/Registration"
import User from "./js/LOGIN/User"
import Passrecovery from "./js/LOGIN/PassRecovery"
import ProtectedRoute from "./js/LOGIN/ProtectedRoute"
import NotFound from "./js/NotFound"

import GetInfoBlock from "./js/GetInfoBlock"

import './css/App.css';
import './css/index.css';
import './css/logo.css';

import "./css/login.css";
import "./css/lk.css";
import "./css/editable.css";

import './css/effects.css';
import './css/footer.css';
import './css/styles.css';
import './css/infoblock.css';
import './css/BlueLine.css';
import './css/mob.css'
import './css/loader.css';

import local from './app_localisation';

var renders = 0;
var mainPic = null;

import { SET_NAVBASES, LOAD_NAV_IDS, SET_TOPNAV, SET_LANG } from './redux/reducers/site';

function App() {

  const dispatch = useDispatch()
  const setup = useSelector(state => state.site.setup);
  const loged = window.localStorage.uloged;

  let large = useMedia("(min-width:650px)");

const [NavIDIs, setNavIDIs] = useState({loading:true, error:false});

let location = useLocation();
let url = location.pathname;
let parts = url.split('/');

// ЯЗЫКОВАЯ ВАЛИДАЦИЯ: проверяем что язык валиден (ru, en, de), иначе используем 'ru' по умолчанию
let LANG = ['ru', 'en', 'de'].includes(parts[1]) ? parts[1] : 'ru';


 useEffect(() => {
  LoadNavIDs(LANG);
  }, [LANG] );


if(NavIDIs.error){
  return <p>AppJS: {NavIDIs.error.message}</p>
}

  // Константы для путей к ресурсам
  const homeLink = setup.domen+setup.folder;
  const logoSrc = homeLink+'/svg/LOGO_CONDTROL.svg';

  const BlBG = {
    backgroundImage: `url(${homeLink+'/pics/'+mainPic})`,
    backgroundSize: 'cover',
    backgroundPosition: '50% center',
    filter: "blur(12px)",
    minWidth: "100%",
    minHeight: "100%",
    position: "fixed",
    opacity: "0.5",
    zIndex: -1,
    top: 0,
    left: 0
  };

return (
  <Fragment>
      <Helmet>
        <title>{local[LANG].title}</title>
        <meta name="description" content={local[LANG].description} />
        <meta name="keywords" content={local[LANG].keywords} />
      </Helmet>
        <div className="App">
          {
            large ? //Десктоп версия
            <Fragment>
              <div className='LogoPlate'>
                <div>
                  <a href={import.meta.env.VITE_DOMEN || import.meta.env.VITE_BASE_PATH || '/'} title={local[LANG].gotosite}>
                    <img src={logoSrc} className="logo" alt=""/>
                  </a>
                  {
                    NavIDIs.loading ? null
                    :
                    <Fragment>
                      {
                        loged? <UserMenu/> : <LoginMenu/>
                      }
                    </Fragment>
                  }
                </div>
              </div>
              <div className='RedLine'>
                <span>{local[LANG].redline}</span>
              </div>
            </Fragment>
          : //мобильная версия
          <Fragment>
          <div className='LogoPlate'>
            <a href={import.meta.env.VITE_DOMEN || import.meta.env.VITE_BASE_PATH || '/'} title={local[LANG].gotosite}>
              <img src={logoSrc} className="logo" alt={local[LANG].gotosite}/>
            </a>
            {
            NavIDIs.loading ? null
            :
            <Fragment>
              {
                loged? <UserMenu/> : <LoginMenu/>
              }
            </Fragment>
            }
          </div>
          <div className='RedLine'>
               <span>{local[LANG].redline}</span>
           </div>
          </Fragment>
          }

          {
              NavIDIs.loading ?
              <ShapkaPreloader/>
              :
              <Fragment>
                {
//                  <TopTelephones/>
                }

                <Routes>
                      <Route exact path="/:lang" element={<RHome/>}/>
                      <Route exact path="/:lang/home" element={<RHome/>}/>
                      <Route exact path="/:lang/login" element={<RLogin/>}/>
                      <Route exact path="/:lang/user" element={<ProtectedRoute><RUser/></ProtectedRoute>}/>
                      <Route exact path="/:lang/logout" element={<RLogOut/>}/>
                      <Route exact path="/:lang/signup" element={<RRegistration/>}/>
                      <Route exact path="/:lang/precovery" element={<RPassRecovery/>}/>
                      <Route path="*" element={<NotFound />} />
                </Routes>
              </Fragment>
            }

        </div>
    </Fragment>
  );

  function RHome(){
    return(
    <Fragment>
      <div className='BlueLine'>
        <img src={homeLink+'/pics/'+mainPic} className='MainPic'/>
      </div>
      <section>
        {
        large? <MainPage_DeskTop /> : <MainPage_Mobile lang={LANG} />
        }
      </section>
      <Footer tel={true}/>
    </Fragment>
    )
  }


  function RLogin() {
    return (
      <Fragment>
        <div className='BlueLine fbg fl11'>
          <Login />
          <div style={BlBG}/>
        </div>
        <section className='tac ftab fl01'>
          <div className='pages'>
            <GetInfoBlock blk='agree' ttl="yes"/>
          </div>
        </section>
        <Footer tel={true}/>
      </Fragment>
    )
  }

  function RRegistration() {
    return (
      <Fragment>
        <div className='BlueLine fbg fl11'>
          <Registration />
          <div style={BlBG}/>
        </div>
        <section className='tac ftab fl01'>
          <div className='pages'>
            <GetInfoBlock blk='agree' ttl="yes"/>
          </div>
        </section>
        <Footer tel={true}/>
      </Fragment>
    )
  }

  function RPassRecovery() {
    return (
      <Fragment>
        <div className='BlueLine fbg fl11'>
          <Passrecovery />
          <div style={BlBG}/>
        </div>
        <section className='tac ftab fl01'>
          <div className='pages'>
            <GetInfoBlock blk='agree' ttl="yes"/>
          </div>
        </section>
        <Footer tel={true}/>
      </Fragment>
    )
  }


  function RUser() {
    return (
    <Fragment>
      <div className='BlueLine fbg fl11'>
        <User />
        <img src={homeLink+'/pics/'+mainPic} className='LoginBG'/>
      </div>
      <section className='tac ftab fl01'>
      </section>
      <Footer tel={true}/>
    </Fragment>
    )
  }

  function RLogOut() {
    return (
      <div className='BlueLine'>
        <LogOut />
      </div>
    )
  }

  function LoadNavIDs(lang){
    setNavIDIs({ error:false, loading:true });
  const form = new FormData()
        form.append('baseQ', setup.bases);
        form.append('lang', lang+'/');
  const MyInit = { method: 'POST', body: form };

  fetch(homeLink+setup.api+'init', MyInit )
    .then(response => {
      if (response.ok) {
        return response.json();
        } else {
          throw new Error(response.text()+'Something went wrong ...');
        }
      })
    .then(data => {
      let man = data.man.i;
      let mans = [];
      let manid = [];
      let bases_id2num = [];
      let bases_id2itm = [];
      mainPic = data.mainpic;

      man.map((i) => mans[i.ttl] = i);
      man.map((i) => manid[i.id] = i);

      data.navid.map((i, key)=>{ bases_id2num[i.id] = key });
      data.navid.map((i, key)=>{ bases_id2itm[i.id] = i });

      dispatch( SET_NAVBASES( {nums:bases_id2num, itms:bases_id2itm} ) );
      dispatch( LOAD_NAV_IDS(data.navid) );
      dispatch( SET_TOPNAV(data.topnav.mnu) );
      dispatch( SET_LANG(lang) );

      setNavIDIs({loading:false, error:false });


    })
    .catch(error => {
      setNavIDIs({ error:true, message: error.message, loading:false });
    });

  }

function Footer() {
  return (
    <div className="footer">
        <GetInfoBlock blk="footer"/>
    </div>
  );
}

function TopTelephones(p) {
  return ( large?
        <Fragment>
             <div className="toptels">
              <div>
                <GetInfoBlock className="toptext" blk="toptext"/>
              </div>
             <GetInfoBlock blk="toptels"/>
            </div>
        </Fragment>
        :
        null
  );
}


}

export default App;
